<template lang='html'>
  <section class='week'>

    <v-expansion-panel-header class="pt-0 pb-0" color="white">
      <section class='weekSummary'>
        <v-row no-gutters class="subtitle-1 d-flex flex-row">
          <v-col cols="auto" class="">
            <v-card class="pa-2 font-weight-bold d-flex flex-column" flat color='transparent'>
              <label :id="'calendarWeekHeader-' + weekData.calendarWeek" class="overline darkgrey-tableheader">{{fromToOfWeek}}</label>
              <label :id="'calendarWeek-' + weekData.calendarWeek">KW{{weekData.calendarWeek}}</label>
            </v-card>
          </v-col>
          <v-col cols="auto" class="d-flex flex-grow-1">
            <UserHoursSummary :displayData="weekData" :visibility="{hideHoursWorked: false}" :extrapolateFlexTime="extrapolateFlexTime"></UserHoursSummary>
          </v-col>
        </v-row>
      </section>
    </v-expansion-panel-header>

    <v-expansion-panel-content color="white" class="pa-0 ma-0">
      <section class='days'>
        <v-expansion-panels multiple hover accordion class="pa-0" v-model="expandedDays">
            <v-expansion-panel v-for="day in weekData.days" :key="day.date" :class="'pa-0 pl-3 '+ getStatusColor(day.status)" ref="dayPanels">
              <UserDay :dayData="day" :extrapolateFlexTime="extrapolateFlexTime" :entryUpdateEnabled="entryUpdateEnabled"></UserDay>
            </v-expansion-panel>
        </v-expansion-panels>
      </section>
    </v-expansion-panel-content>
  </section>
</template>

<script lang="js">
  import UserDay from '@components/user/UserDay.vue';
  import UserHoursSummary from '@components/user/UserHoursSummary.vue';
  import StatusColorCalculator from '@/mixins/StatusColorCalculator.vue'

  import _ from 'lodash';
  import dayjs from '@util/dayjs';

  export default {
    name: 'weekSummary',
    props: ['weekData', 'extrapolateFlexTime', 'entryUpdateEnabled', 'monthTableRef'],
    mixins: [StatusColorCalculator],
    data() {
      return {
        expandedDays: []
      }
    },

    created() {
      this.monthTableRef.$on('expandAllDays', this.expandAllDays);
      this.monthTableRef.$on('collapseAllDays', this.collapseAllDays);
      this.monthTableRef.$on(`jumpToActivity-${this.weekData.calendarWeek}`, this.jumpToActivity);
      this.monthTableRef.$on(`jumpToDate-${this.weekData.calendarWeek}`, this.jumpToDate);
    },

    beforeDestroy() {
      this.monthTableRef.$off('expandAllDays', this.expandAllDays);
      this.monthTableRef.$off('collapseAllDays', this.collapseAllDays);
      this.monthTableRef.$off(`jumpToActivity-${this.weekData.calendarWeek}`, this.jumpToActivity);
      this.monthTableRef.$off(`jumpToDate-${this.weekData.calendarWeek}`, this.jumpToDate);
    },

    components: {
      UserDay,
      UserHoursSummary
    },
    computed: {
      fromToOfWeek: function() {
        return dayjs(_.head(this.weekData.days).date).format('DD.') + '-' + dayjs(_.last(this.weekData.days).date)
          .format('DD.MM.');
      }
    },
    methods: {
      expandAllDays() {
        this.expandedDays = [];
        for (let i = 0; i < this.weekData.days.length; i++) {
          this.$set(this.expandedDays, i, i);
        }
      },

      collapseAllDays() {
        this.expandedDays = [];
      },

      jumpToActivity(activity) {
        const dayIndex = this.weekData.days.findIndex(day => day.date === activity.date);
        if (!this.expandedDays.includes(dayIndex)) {
          this.expandedDays.push(dayIndex);
        }

        let attempts = 0;
        let unchangedTicks = 0; // how many ticks the position of the activity has not changed significantly
        let lastOffset = -1;    // the Y coordinate of the activity in the last tick

        const interval = setInterval(() => {
          const dayPanelElement = this.$refs.dayPanels?.[dayIndex]?.$el;
          const activityRow = dayPanelElement?.querySelector(`[data-activity-id="${activity.id}"]`)?.closest('tr');
          if (!activityRow) {
            if (++attempts > 10) { // stop if after 10 attempts the activity row is not found
              clearInterval(interval);
            }

            return;
          }

          //current Y coordinate of the activity row
          const currentOffset = activityRow.getBoundingClientRect().top + window.scrollY;

          //checks if the activity row has moved by 1px since the last tick
          if (Math.abs(currentOffset - lastOffset) >= 1) {
            unchangedTicks = 0;
          } else if (++unchangedTicks >= 5) {
            clearInterval(interval);
            activityRow.scrollIntoView({ block: 'center', behavior: 'smooth' });
            activityRow.classList.add('row-highlight-pulse');

            const presenceRow = dayPanelElement?.querySelector(`[data-presence-id="${activity.presenceId}"]`)?.closest('tr');
            presenceRow?.classList.add('row-highlight-pulse');

            setTimeout(() => {
              activityRow.classList.remove('row-highlight-pulse');
              presenceRow?.classList.remove('row-highlight-pulse');
            }, 3000);
          }
          lastOffset = currentOffset;
        }, 100);
      },

      jumpToDate(date) {
        const dayIndex = this.weekData.days.findIndex(day => day.date === date);
        if (!this.expandedDays.includes(dayIndex)) {
          this.expandedDays.push(dayIndex);
        }

        setTimeout(() => {
          const dayPanelElement = this.$refs.dayPanels?.[dayIndex]?.$el;
          const header = dayPanelElement?.querySelector('.v-expansion-panel-header');
          if (!header) {
            return;
          }
          
          header.scrollIntoView({ block: 'center', behavior: 'smooth' });
          header.classList.add('row-highlight-pulse');

          setTimeout(() => {
            header.classList.remove('row-highlight-pulse');
          }, 3000);

        }, 500);
      }
    }
  }
</script>
<style lang="scss">
@keyframes highlight-shadow-pulse {
  0%   { box-shadow: inset 0 0 0 9999px rgba(255, 235, 59, 1); }
  40%  { box-shadow: inset 0 0 0 9999px rgba(255, 235, 59, 1); }
  100% { box-shadow: inset 0 0 0 9999px rgba(255, 235, 59, 0); }
}

.row-highlight-pulse,
.row-highlight-pulse td,
.v-expansion-panel-header.row-highlight-pulse {
  animation: highlight-shadow-pulse 2.25s forwards !important; 
}
</style>